export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL = 'EdlNd';
export const NAME = 'NdEdl';

export const POLOZKY = 'Polozky';
export const ND_PRIJEMKA = 'NdPrijemka';

export const X_VYROBEKND_OZN = 'X_VYROBEKND_OZN';
export const X_SKLAD_OZN = 'X_SKLAD_OZN';
export const VYROBEKND_OZN = 'VYROBEKND_OZN';
export const SKLAD_OZN = 'SKLAD_OZN';
export const X_SKLADMISTO_ID = 'X_SKLADMISTO_ID';
export const 	TEXT = 'TEXT';
export const POZNAMKA = 'POZNAMKA';

export const POLOZKY_COLS = {
	X_VYROBEKND_OZN,
	X_SKLAD_OZN,
	VYROBEKND_OZN,
	SKLAD_OZN,
	X_SKLADMISTO_ID,
	TEXT,
	POZNAMKA,
};

export const POLOZKY_COLS_EDIT_FLAG = {
	X_VYROBEKND_OZN: 1,
	X_SKLAD_OZN: 2,
	TEXT: 4,
	X_SKLADMISTO_ID: 8,
	POZNAMKA: 128,
};
